<mat-checkbox #input
  name="value"
  [class.iris-mat-checkbox]="isFalseValue"
  [class.mat-checkbox-indeterminate]="isNullValue"
  [(indeterminate)]="indeterminateEnabled"
  [color]="checkboxColor"
  [formControl]="valueControl">{{ label }}</mat-checkbox>
